import ListQueryFunctionGenerator from "./ListQueryFunctionGenerator";

// prettier-ignore
const ENDPOINT = (shipmentId: string) => `shipments/${shipmentId}/sections`;

export default ListQueryFunctionGenerator(ENDPOINT);
